import type { FetchQueryOptions, QueryClient } from '@tanstack/react-query';

import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';
import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type TCianApiSiteV1GetUserDataByRequestResponse_1 } from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

import { type QueryError, type QueryKey, getQueryKey } from './internal/config';
import { fetchCianApiSiteV1GetUserDataByRequestService } from './internal/fetchService';

export class FetchGetUserLoadService {
  private readonly queryClient: QueryClient;

  public constructor(queryClient: QueryClient) {
    this.queryClient = queryClient;
  }

  public prefetchQuery<TData = TCianApiSiteV1GetUserDataByRequestResponse_1>(
    dependencies: IQueryStateAppContext,
    options?: FetchQueryOptions<TCianApiSiteV1GetUserDataByRequestResponse_1, QueryError, TData, QueryKey>,
  ): Promise<void> {
    return this.queryClient.prefetchQuery<TCianApiSiteV1GetUserDataByRequestResponse_1, QueryError, TData, QueryKey>({
      queryFn: () => fetchCianApiSiteV1GetUserDataByRequestService(dependencies),
      queryKey: getQueryKey(),
      ...options,
    });
  }

  public getQueryData(): TCianApiSiteV1GetUserDataByRequestResponse_1 | null {
    return extractUndefined(this.queryClient.getQueryData<TCianApiSiteV1GetUserDataByRequestResponse_1>(getQueryKey()));
  }

  public setQueryData(
    updater: TCianApiSiteV1GetUserDataByRequestResponse_1,
  ): TCianApiSiteV1GetUserDataByRequestResponse_1 | null {
    return extractUndefined(
      this.queryClient.setQueryData<TCianApiSiteV1GetUserDataByRequestResponse_1>(getQueryKey(), updater),
    );
  }
}
